import { useApolloClient } from "@apollo/client";
import { gql } from "__generated__/gql";
import useSignedUrlDownload from "utils/files/useSignedUrlDownload";
import { assertPresence } from "utils/assertions";

export const signedUrlQuery = gql(/* GraphQL */ `
  query BrandDocumentSignedUrl(
    $documentId: UUID!
    $attachmentFilename: String
  ) {
    brandDocument(id: $documentId) {
      id
      fileUrl(attachmentFilename: $attachmentFilename)
    }
  }
`);

export default function useDownloadBrandDocument() {
  const client = useApolloClient();
  return useSignedUrlDownload(async (documentId, filename) => {
    const { data } = await client.query({
      fetchPolicy: "no-cache",
      query: signedUrlQuery,
      variables: { documentId, attachmentFilename: filename },
    });
    assertPresence(
      data.brandDocument?.fileUrl,
      "Could not get signed URL from response!",
    );
    return data.brandDocument.fileUrl;
  });
}
